// 15 * 60 * 1000
export const DEFAULT_SENTINEL_ESCALATION_SINGLE_RUN_DELAY = 900000;

// 30 * 60 * 1000
export const DEFAULT_SENTINEL_RECUR_INTERVAL = 1800000;

export const DEFAULT_MAXIMUM_RESENDS = 5;

export const DEFAULT_HALT_KEYS = 'phone';
